module.exports = __webpack_public_path__ + "static/media/27OCHA2.e576f085.jpg";